import { takeLatest, put, select, call, all } from 'redux-saga/effects';
import { takeOnce } from 'src/helpers/effects';
import { isEmpty } from 'lodash';

import { api } from 'src/api';

import { updateDate } from 'src/utils/dateUtils';

import { getSearchParamsRequestId } from 'src/store/enqueue/selectors';
import { getIsHotelOnly } from 'src/store/view/selectors';
import {
  priceChartFetchingDirectionSelector,
  priceChartResultSelector,
} from './selectors';
import { isExpandableMapSelector } from '../map/selectors';

import { COUNT, FETCH_PRICE_CHART } from './constants';

import { setPriceChart, fetching, paginationDirection } from './slice';

function* getPriceChart(props) {
  yield put(fetching());

  const requestId = yield select(getSearchParamsRequestId);
  const isHotelOnly = yield select(getIsHotelOnly);

  // для отелей не покатываем статистику цен и не делаем запрос
  if (isHotelOnly) {
    return;
  }

  try {
    const response = yield api.getSearchBlocksSearchPriceChart({
      request_id: requestId,
      start_date: props?.start_date,
      range: COUNT,
    });

    if (!isEmpty(response?.result)) {
      yield put(setPriceChart(response));
    }
  } catch (error) {
    console.error(error);
  }
}

/**
 * Формируем новую дату для пагинации
 */
function* getPaginationParams() {
  const data = yield select(priceChartResultSelector);
  const direction = yield select(priceChartFetchingDirectionSelector);

  const isNextDirection = direction === 'next';
  const index = isNextDirection ? -1 : 0;
  const date = data.at(index).start_date;
  const nextDate = updateDate({ date, direction, daysCount: 1 });

  const daysCount = COUNT / 2;

  const newStartDate = updateDate({ date: nextDate, direction, daysCount });
  return newStartDate;
}

function* priceChartPagination() {
  const start_date = yield call(getPaginationParams);

  yield call(getPriceChart, { start_date });
}

/**
 * При раскрытии карты на десктопе, загружаем дополнительные данные
 * тк при раскрытии статистика цен растягивается на ширину карты
 */
function* loadMoreForExpandableMap() {
  const isExpandableMap = yield select(isExpandableMapSelector);

  if (isExpandableMap) {
    yield put(paginationDirection('next'));
  }
}

export default function* priceChartSaga() {
  yield all([
    takeLatest(FETCH_PRICE_CHART, getPriceChart),
    takeLatest(paginationDirection.type, priceChartPagination),
    takeOnce(setPriceChart.type, loadMoreForExpandableMap),
  ]);
}
